import { Dispatch } from 'redux';

import { requestHandler } from '../../../api';

export const getDataHubLightReport = async (
  dispatch: Dispatch,
  id: number,
  query?: string,
): Promise<Blob | undefined> => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/datahub/reports/dataHubLightReport/${id}${query ? `?${query}` : ''}`,
    dispatch,
    responseType: 'blob',
  });
  if (response) return response.data;
};
